import { createSelector } from 'redux-bundler';
import errorsExist from 'utils/errorsExist';

import { READ_BOARDS_BY_ORGANIZATION } from '../../boards';
import { READ_ORGANIZATION } from '../../organizations';
import { READ_TEAM_BY_ORGANIZATION } from '../../teams';

// General Page Has Errors
export const selectGeneralPageHasErrors = createSelector(
  'selectErrors',
  (errors) => errorsExist([READ_ORGANIZATION], errors),
);

// Teams Page Has Errors
export const selectTeamPageHasErrors = createSelector(
  'selectErrors',
  (errors) =>
    errorsExist(
      [READ_TEAM_BY_ORGANIZATION, READ_BOARDS_BY_ORGANIZATION],
      errors,
    ),
);

// Workspaces Page Has Errors
export const selectWorkspacesPageHasErrors = createSelector(
  'selectErrors',
  (errors) =>
    errorsExist(
      [READ_TEAM_BY_ORGANIZATION, READ_BOARDS_BY_ORGANIZATION],
      errors,
    ),
);
